export default __webpack_public_path__ + "f3ddf146428775b48e001245afd58f07.svg";